<template>
  <Teleport to="body">
    <div
      v-if="modelValue"
      class="modal is-active"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="invalid-dv-title"
      aria-describedby="invalid-dv-message"
      @keydown.esc="close"
    >
      <div class="modal-background" @click="close"></div>
      <div ref="dialogRef" class="modal-card invalid-dv-dialog">
        <header class="modal-card-head">
          <p id="invalid-dv-title" class="modal-card-title">
            <span class="icon has-text-warning mr-2"
              ><i class="fas fa-exclamation-triangle"></i
            ></span>
            Not a Daily Value Nutrient
          </p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section id="invalid-dv-message" class="modal-card-body">
          <p class="mb-3">
            <strong>"{{ ingredientName }}"</strong> is not a recognized nutrient with an established
            Daily Value.
          </p>
          <p>
            Only vitamins, minerals, and other FDA-recognized nutrients can be added to
            <strong>Ingredients with Daily Values</strong>.
          </p>
          <div class="notification bordered-left is-info mt-3">
            <strong>Tip:</strong> Add this ingredient to the
            <strong>Ingredients without DVs</strong> section instead.
          </div>
        </section>
        <footer class="modal-card-foot is-justify-content-flex-end">
          <button ref="confirmButtonRef" class="button is-info" @click="close">Got it</button>
        </footer>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
  import { ref, watch, nextTick } from "vue";

  const props = defineProps({
    modelValue: { type: Boolean, default: false },
    ingredientName: { type: String, default: "" },
  });

  const emit = defineEmits(["update:modelValue", "close"]);

  const dialogRef = ref(null);
  const confirmButtonRef = ref(null);
  const previousActiveElement = ref(null);

  function close() {
    emit("update:modelValue", false);
    emit("close");
    nextTick(() => {
      previousActiveElement.value?.focus?.();
    });
  }

  watch(
    () => props.modelValue,
    (isOpen) => {
      if (isOpen) {
        previousActiveElement.value = document.activeElement;
        nextTick(() => {
          confirmButtonRef.value?.focus();
        });
      }
    }
  );
</script>

<style scoped>
  .invalid-dv-dialog {
    max-width: 450px;
    width: 100%;
  }
  .modal-card-body {
    font-size: 1rem;
  }
</style>
